import { render } from "./PolicyAccount.vue?vue&type=template&id=9c68e022&scoped=true"
import script from "./PolicyAccount.vue?vue&type=script&lang=js"
export * from "./PolicyAccount.vue?vue&type=script&lang=js"

import "./PolicyAccount.vue?vue&type=style&index=0&id=9c68e022&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c68e022"]])

export default __exports__